import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import './SitePlans.css';
import AssetsManager from '../assets_management/AssetsManager';
import isMobile from '../core/isMobile';
import SitePlanWrapper from './SitePlanWrapper';
import SiteJsons from '../site/SiteJsons';
import Iterator from '../core/Iterator';
import NFilteredSitePlansToShow from '../enums/NFilteredSitePlansToShow';
import HouseTypesViewModel from '../view_models/HouseTypesViewModel';
import DropdownSelectorMenu from '../components/DropdownSelectorMenu';
import Spinner from '../components/Spinner';
import Handles from '../core/Handles';
import Dialog from './Dialog';
import WhatAreYouLookingFor from '../what_are_you_looking_for/WhatAreYouLookingFor';
export default class SitePlans {
	constructor(){
		this._element = document.createElement('div');
		this._element.classList.add('site-plans');
		this._element.classList.add('single-site');
		this._sitePlansWrapperElement= document.createElement('div');
		this._sitePlansWrapperElement.classList.add('site-plans-wrapper');
		this._sitePlanSelectorMenu = new DropdownSelectorMenu({
			classNames:'site-plan-selector-menu',
			defaultTitle:'Select Site'
		});
		this._element.appendChild(this._sitePlanSelectorMenu.element);
		this._element.appendChild(this._sitePlansWrapperElement);
		this._mapSiteSlugToSitePlanWrapper = new Map();
		this._createSitePlan= this._createSitePlan.bind(this);
		this.initialize= this.initialize.bind(this);
		this._showPlotsExplanationDialog= this._showPlotsExplanationDialog.bind(this);
		this._setupSiteSelectorMenu= this._setupSiteSelectorMenu.bind(this);
		this._getSiteJsonsWithPlots= this._getSiteJsonsWithPlots.bind(this);
		this._loadSitesForSiteJsons= this._loadSitesForSiteJsons.bind(this);
		this._getSetWindowVisibilityForSitePlan= this._getSetWindowVisibilityForSitePlan.bind(this);
		this._setFilterInSitesFromWhatAreYouLookingFor= this._setFilterInSitesFromWhatAreYouLookingFor.bind(this);
		if(AssetsManager.configuration.whatAreYouLookingForEnabled){
			this._whatAreYouLookingFor = new WhatAreYouLookingFor({});
			this._element.appendChild(this._whatAreYouLookingFor.element);
		}
		this._spinnerWrapperElement = document.createElement('div');
		this._element.appendChild(this._spinnerWrapperElement);
		this._spinnerHandles = new Handles();
		const spinnerFactory = React.createFactory(Spinner);
		ReactDOM.render(spinnerFactory(
			{ 
				spinnerHandles:this._spinnerHandles, invertHandles:false
			}),
			this._spinnerWrapperElement);
		this._spinnerHandleLoading = this._spinnerHandles.take();
	}
	_setFilterInSitesFromWhatAreYouLookingFor (whatAreYouLookingForViewModel){
		console.log('_setFilterInSitesFromWhatAreYouLookingFor');
		return new Promise((resolve, reject)=>{
			this._getSiteJsonsWithPlots({andElseOr:true, whatAreYouLookingForViewModel}).then((siteJsonsWithPlots)=>{
				if(siteJsonsWithPlots.length>0){	
					this._loadSitesForSiteJsons(siteJsonsWithPlots, whatAreYouLookingForViewModel).then(resolve).catch(reject);;	
					return;
				}			
				this._getSiteJsonsWithPlots({andElseOr:false, whatAreYouLookingForViewModel}).then((siteJsonsWithPlots)=>{
					if(siteJsonsWithPlots.length>0){	
						this._loadSitesForSiteJsons(siteJsonsWithPlots, whatAreYouLookingForViewModel).then(resolve).catch(reject);
						this._showPlotsExplanationDialog( 
							'No plots matched all filters for any site. The active plots matched some of the filters for these sites!');
						resolve();
						return;
					}	
					this._showPlotsExplanationDialog( 
						'No available plots currently match what you’re looking for for any site, please see other available plots below');
					this._loadSitesForSiteJsons(this._siteJsons.entries, whatAreYouLookingForViewModel)
						.then(resolve).catch(reject);
				}).catch(reject);
			}).catch(reject);
		});
	}
	_showPlotsExplanationDialog(message){
		Dialog.create({
			title:'Info', 
			className:'brochure-generation-result-dialog error',
			message:message,
			options:[{text:'OK', callback:()=>{
				
			}}]}
		);
	}
	_loadSitesForSiteJsons(siteJsons, whatAreYouLookingForViewModel){
		return new Promise((resolve, reject)=>{
			const siteJsonsIterator = new Iterator(this._siteJsons.entries);
			const sitePlanWrappers =[];
			const setWindowVisibilityForSitePlan = this._getSetWindowVisibilityForSitePlan();
			const doNext = ()=>{
				if(!siteJsonsIterator.hasNext()){
					if(sitePlanWrappers.length>1){
						this._element.classList.remove('single-site');
						this._sitePlanSelectorMenu.element.classList.add('visible');	
					}
					this._setupSiteSelectorMenu(sitePlanWrappers);
					resolve();
					return;
				}
				const siteJson= siteJsonsIterator.next();
				const hasFilteredOptions = siteJsons.indexOf(siteJson)>=0;
				this._createSitePlan(siteJson.configuration, hasFilteredOptions,
					setWindowVisibilityForSitePlan).then((sitePlanWrapper)=>{
					sitePlanWrappers.push(sitePlanWrapper);
					if(hasFilteredOptions)
						sitePlanWrapper.sitePlan.setFilterInSiteFromWhatAreYouLookingFor(
							whatAreYouLookingForViewModel);
					doNext();
				}).catch(reject);
			};
			doNext();
		});
	}
	_setupSiteSelectorMenu(sitePlanWrappers){
		this._sitePlanSelectorMenu.setEntries(
			sitePlanWrappers.map(sitePlanWrapper=>{
				return {
				value:sitePlanWrapper, 
				callback:(e)=>sitePlanWrapper.show(),
				text:sitePlanWrapper.siteName,
				classNames:(sitePlanWrapper.hasFilteredOptions?'has-filtered-options':'has-no-filtered-options')
			};})
		);
	}
	_getSiteJsonsWithPlots({andElseOr, whatAreYouLookingForViewModel}){
		return new Promise((resolve, reject)=>{	
			const siteJsonsWithPlots = [];
			const iteratorSiteJsons = new Iterator(this._siteJsons.entries);
			const doNextSiteJson = ()=>{
				if(!iteratorSiteJsons.hasNext()){
					resolve(siteJsonsWithPlots);
				}
				const siteJson = iteratorSiteJsons.next();
				const plotsArray = siteJson.getPlotsArray();
				const plotsStillAvailable = andElseOr
					?whatAreYouLookingForViewModel.getPlotsStillAvailableForSite(siteJson)
					:whatAreYouLookingForViewModel.getPlotsStillAvailableWithOr(siteJson);
				for(var plotStillAvailable of plotsStillAvailable){
					if(plotsArray.indexOf(plotStillAvailable)>=0){
						siteJsonsWithPlots.push(siteJson);
						break;
					}
				}
				doNextSiteJson();
			};
			doNextSiteJson();
		});
	}
	initialize(){
		return new Promise((resolve, reject)=>{
			const doThen = ()=>{
				this._spinnerHandleLoading.dispose();
				resolve();
			};
			const doCatch = (err)=>{
				this._spinnerHandleLoading.dispose();
				reject(err);
			};
			if(this._whatAreYouLookingFor){		
				this._siteJsons = new SiteJsons();
				this._siteJsons.initialize().then(()=>{
					this._houseTypesViewModel = new HouseTypesViewModel(this._siteJsons.getPlotsArray());
					this._whatAreYouLookingFor?.initialize({siteJsons:this._siteJsons, 
						houseTypesViewModel:this._houseTypesViewModel, 
						setFilterInSite:this._setFilterInSitesFromWhatAreYouLookingFor});
						doThen();
				}).catch(doCatch);
				return;
			}
			this._createSitePlan(AssetsManager.configuration, true, this._getSetWindowVisibilityForSitePlan())
				.then(doThen).catch(doCatch);
		});
	}
	get element(){
		return this._element;
	}
	_createSitePlan(configuration, hasFilteredOptions, setWindowVisibilityForSitePlan){
		let sitePlanWrapper = this._mapSiteSlugToSitePlanWrapper.get(configuration.siteSlug);
		if(sitePlanWrapper){
			if(hasFilteredOptions)
				setWindowVisibilityForSitePlan(sitePlanWrapper);
			return new Promise((resolve, reject)=>resolve(sitePlanWrapper));
		}
		sitePlanWrapper = new SitePlanWrapper({
			configuration, 
			parentElement:this._sitePlansWrapperElement,
			hasFilteredOptions,
			siteJsons:this._siteJsons
		});
		this._mapSiteSlugToSitePlanWrapper.set(configuration.siteSlug, sitePlanWrapper);
		this._sitePlansWrapperElement.appendChild(sitePlanWrapper.element);
		if(hasFilteredOptions)
			setWindowVisibilityForSitePlan(sitePlanWrapper);
		return new Promise((resolve, reject)=>{
			sitePlanWrapper.initialize().then(()=>resolve(sitePlanWrapper)).catch(reject);
		});
	}
	_getSetWindowVisibilityForSitePlan(){
		const nFilteredSitePlansToShow =  AssetsManager.configuration.nFilteredSitePlansToShow;
		let firstSitePlanWrapper = null;
		return (sitePlanWrapper)=>{
			const nExistingSitePlans = this._mapSiteSlugToSitePlanWrapper.size;
			const isFirst = nExistingSitePlans<=1;
			if(!window.isMobile&& nFilteredSitePlansToShow===NFilteredSitePlansToShow.Two){
				if(isFirst){
					firstSitePlanWrapper = sitePlanWrapper;
					sitePlanWrapper.show(true);
					return;
				}
				const isSecond = nExistingSitePlans<=2;
				if(isSecond){
					firstSitePlanWrapper.fillLeftHalf();
					sitePlanWrapper.fillRightHalf();
				}
				return;
			}
			if(isFirst)
				sitePlanWrapper.show(true);
		};
	}
}
